/**
 * BackgroundDisplayMode - UI-only enum for board background display options
 *
 * Not a database enum — this is purely a frontend display concern.
 * Stored as a string in board_preferences JSONB config.
 */
export enum BackgroundDisplayMode {
  COVER = 'cover',
  CONTAIN = 'contain',
  TILE = 'tile',
  CENTER = 'center',
  STRETCH = 'stretch',
}
